/******/ (() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {
      const data = Shopify.theme.getSectionData($section) || {};
      const $sliderEl = $section.find('[data-slider]');
      let flkty = null; // store Flickity instance

      function initSlider() {
        if (window.innerWidth <= data.mobile_breakpoint && !flkty) {
          flkty = new Flickity($sliderEl[0], {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            prevNextButtons: true, // disable built-in arrows
            groupCells: 1,
            draggable: true,
            wrapAround: false,
          });

          // Hook up your custom arrows
          $section.find('.custom-prev-svg').on('click', function () {
            if (flkty) flkty.previous();
          });

          $section.find('.custom-next-svg').on('click', function () {
            if (flkty) flkty.next();
          });

        } else if (window.innerWidth > data.mobile_breakpoint && flkty) {
          flkty.destroy();
          flkty = null;
        }
      }

      initSlider();
      window.addEventListener('resize', initSlider);
    }
  };
})();